export default {
  SituationCenter: 'Situation Center',
  FullScreenDisplay: 'Full Screen',
  ExitFullScreen: 'Exit Full Screen',
  InternetStatisticsOfEndUsers: 'End-user Internet Statistics',
  GatewayDisasterToleranceAnalysis: 'Gateway status statistics',
  ServiceHealthAnalysis24Hours: 'Service health analysis in the past 12 hours',
  AlarmEventMonitoring24H: 'Nearly 12h alarm event monitoring',
  BranchTrafficUsageTop5: 'Branch peak bandwidth usage in the last 12 hours (top5)',
  BandwidthUsageStatistics24H: 'Statistics on export bandwidth usage in the past 12 hours',
  UpstreamAndDownlinkBandwidthTrends24H: 'Trend chart of upstream and downstream bandwidth in the past 12 hours',
  KeyQualityIndicators24H: 'Key quality indicators in the past 12 hours',
  EndUsersNumber: 'Number of end users',
  Piece: 'piece',
  AlarmEvent24Hours: 'Alarm events in the past 12 hours',
  BandwidthUtilization24Hours: 'Maximum bandwidth usage in recent 12 hours',
  GatewayInService: 'gateway in service',
  OpenDeviceGateway: 'Enable device-level disaster recovery gateway',
  OpenLinkGateway: 'Enable link-level disaster recovery gateway',
  AllGatewayServiceExceptionEvents: 'Gateway service exception events',
  AllGatewayLinkExceptionEvents: 'Gateway link down event',
  DisasterRecoveryGatewayServiceExceptionEvent: 'Disaster Recovery Gateway Service Abnormal Events',
  DisasterRecoveryGatewayLinkExceptionEvent: 'Disaster Recovery Gateway Link Interruption Event',
  AverageTimeOfEquipmentDisasterRecovery: 'Average time for equipment disaster recovery (s)',
  AverageTimeOfLinkDisasterRecovery: 'Average time of link disaster recovery (s)',
  Wired: 'Wired',
  BandWidthAvg: 'Average business bandwidth',
  MonitorDesc: 'Monitoring overview',
  ExcellentTip: 'No critical abnormal event occurred in the past 12 hours',
  GoodTip: 'A critical abnormal event has occurred within the past 12 hours and has been recovered',
  ErrorTip: 'A critical abnormal event has occurred within the past 12 hours and has not recovered',
  HeadBranch: 'headquarters',
  Branch: 'branch',
  ServiceExceptionGateway: 'Service exception gateway',
  Use: 'Use',
  Purchase: 'purchase',
  UplinkBandwidth: 'Uplink bandwidth',
  DownstreamBandwidth: 'Downstream bandwidth',
  Top5branchalarmsinrecent24h: 'Top 5 branch alarms in recent 12h',
}